import { getRgObjectsOfType as a, RG_TYPE as s } from "@project-rouge/rg-core";
import { getLevelGrossFacadeArea as l } from "../level-metrics/index22.js";
const g = (t) => {
  let e = 0;
  const o = a(t, s.Building);
  for (const r of o)
    e += n(r);
  return e;
};
function n(t) {
  let e = 0;
  const o = new Set(t.data.levels.map((r) => r.levelIndex));
  for (const r of o)
    e += l(t, r);
  return e;
}
export {
  g as getGrossFacadeArea
};
//# sourceMappingURL=index28.js.map
